import axios from "axios";

export default {
  checkIban(iban) {
    return new Promise((resolve) => {
      axios({
        method: "get",
        url: `${process.env.CONFIGURATION_SERVICE_PUBLIC_PATH}/iban/blacklist/${iban}`,
      })
        .then(response => {
          return resolve(response.data)
        })
        .catch((error) => {
          console.error(error);
          if(error.response.status === 400 && error.response.data.error === 'iban is invalid') {
            return resolve({blacklisted: null});
          }
          return resolve({blacklisted: false});
        });
    });
  },
}



// WEBPACK FOOTER //
// ./src/services/configurationService.js